import { useIntl } from "react-intl";
import { ArrowIcon } from "@/public/icons/ArrowIcon";
import styles from "./BackButton.module.scss";

type BackButtonProps = {
  path: string;
};
export const BackButton = ({ path }: BackButtonProps) => {
  const intl = useIntl();
  const color = "#3f4756";

  const onClick = () =>
    document.referrer.indexOf(window.location.host) === -1
      ? (window.location.href = path)
      : history.go(-1);

  return (
    <button className={styles.backButton} onClick={onClick}>
      <div className={styles.arrowIcon}>
        <ArrowIcon color={color} size={16} />
      </div>
      <p className={styles.backButtonLabel}>
        {intl.formatMessage({ id: `backButtonLabel` })}
      </p>
    </button>
  );
};
